import React, { useEffect } from 'react';
import './MentorArc.css';
import usePageTitle from '../hooks/usePageTitle';
import borderImage from '../assets/border.png';
import mentorarcImage from '../assets/mentorarc.png';

const MentorArc: React.FC = () => {
  usePageTitle('MentorArc');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Remove animation classes first to reset
    const allElements = document.querySelectorAll('.mentorarc-title, .mentorarc-subtitle, .mentorarc-description, .mentorarc-paragraph');
    allElements.forEach(element => {
      element.classList.remove('animate-in-initial');
    });
    
    // Force reflow to ensure the removal is processed
    void document.body.offsetHeight;
    
    // Animate initial content on page load
    const titleElement = document.querySelector('.mentorarc-title');
    if (titleElement) {
      setTimeout(() => {
        titleElement.classList.add('animate-in-initial');
      }, 200);
    }
    
    // Subtitle animates after title
    const subtitleElements = document.querySelectorAll('.mentorarc-subtitle');
    setTimeout(() => {
      subtitleElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 210);
    
    // Paragraphs animate 200ms after subtitle
    const paragraphElements = document.querySelectorAll('.mentorarc-description, .mentorarc-paragraph');
    setTimeout(() => {
      paragraphElements.forEach(element => {
        element.classList.add('animate-in-initial');
      });
    }, 410);
  }, []);

  return (
    <div className="mentorarc-page">
      <div className="mentorarc-container">
        <h1 className="mentorarc-title">MentorArc Non-Profit</h1>
        <h2 className="mentorarc-subtitle">Student-Led Educational Equity Platform</h2>
        <img src={borderImage} alt="" className="mentorarc-border-image" />
        
        <div className="mentorarc-content">
          <div className="mentorarc-images-section">
            <div className="mentorarc-images-container">
              <img src={mentorarcImage} alt="MentorArc Platform Interface" className="mentorarc-image" />
            </div>
          </div>
          
          <div className="mentorarc-decorative-line"></div>
          
          <div className="mentorarc-text">
            <p className="mentorarc-description">
              Student-led platform dismantling educational inequities through structured peer mentorship. Utilizing sophisticated matching algorithms and culturally responsive frameworks, the initiative connects high school mentors with K-12 students across underserved communities globally. Operating 5+ chapters across three continents—including Vietnam, Pakistan, Canada, and Indonesia—the organization has secured independent funding and established partnerships with New Hope Academy, STEM for Youth, and Pakistan Roots Business Society. The platform advances systemic educational reform through scalable leadership pathways and youth-driven advocacy.
            </p>
            
            <p className="mentorarc-paragraph">
              Sociology & Education | Ongoing
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentorArc;